import React from "react";

interface ProgressBarProps {
  /** Current value (e.g., week number or completed count) */
  value: number;
  /** Maximum value (e.g., total weeks or total activities) */
  max: number;
  /** Label text (e.g., "Week 2 / 6") */
  label?: string;
  /** Size variant */
  size?: "sm" | "md";
  /** Show label on left or above the bar */
  labelPosition?: "left" | "above";
  /** Custom class for container */
  className?: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  max,
  label,
  size = "sm",
  labelPosition = "above",
  className = "",
}) => {
  const percentage = max > 0 ? Math.min(100, (value / max) * 100) : 0;
  const barHeight = size === "sm" ? "h-1.5" : "h-2";

  return (
    <div className={`w-full ${className}`}>
      {label && labelPosition === "above" && (
        <div className="flex items-center py-2">
          <p className="text-sm font-bold text-brand-primary font-dm-sans">
            {label}
          </p>
        </div>
      )}

      <div className="flex items-center gap-3">
        {label && labelPosition === "left" && (
          <span className="text-xs text-gray-500 font-medium whitespace-nowrap">
            {label}
          </span>
        )}

        <div className={`flex-1 bg-gray-100 rounded-full ${barHeight} relative overflow-hidden`} >
          <div
            className={`absolute left-0 top-0 ${barHeight} bg-brand-primary rounded-full transition-all duration-300 ease-out`}
            style={{ width: `${percentage}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
